import { Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { LicenseActions } from "../actions";
import { LicenseSelectors } from "../selectors";

@Injectable()
export class LicenseFacade {
  license$ = this.store.pipe(select(LicenseSelectors.license));
  isLoading$ = this.store.pipe(select(LicenseSelectors.isLoading));

  constructor(private readonly store: Store) {}

  loadLicense() {
    return this.store.dispatch(LicenseActions.loadLicense());
  }
}
